export const normalizeNotificationSoundPreferences = preferences => {
  const value = preferences && typeof preferences === 'object' ? preferences : {}

  const normalizeId = raw => {
    if (raw === null || raw === undefined || raw === '') {
      return null
    }

    const parsed = Number(raw)
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null
  }

  return {
    attendanceMessageSoundId: normalizeId(value.attendanceMessageSoundId),
    internalChatMessageSoundId: normalizeId(value.internalChatMessageSoundId),
    groupMessageSoundId: normalizeId(value.groupMessageSoundId)
  }
}

export const resolveNotificationSoundUrls = (sounds = [], preferences = {}) => {
  const normalizedPreferences = normalizeNotificationSoundPreferences(preferences)
  const soundsById = new Map((sounds || []).map(sound => [Number(sound.id), sound]))

  const getSoundUrl = id => {
    if (!id) return null
    return soundsById.get(Number(id))?.url || null
  }

  return {
    attendanceMessageSoundUrl: getSoundUrl(
      normalizedPreferences.attendanceMessageSoundId
    ),
    internalChatMessageSoundUrl: getSoundUrl(
      normalizedPreferences.internalChatMessageSoundId
    ),
    groupMessageSoundUrl: getSoundUrl(normalizedPreferences.groupMessageSoundId)
  }
}
